// Typelizer digest acd44ddf213a43e331bb5a002d6f8ba5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/sales_documents/:sales_document_id/conversions */
  create: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/conversions', params, options),
    method: 'post',
  }),
}
